import type { BleachingFormParams } from '@witmetrics/unison-core';
import type { BleachingTrayParameterKey } from '@witmetrics/utils';
import { BLEACHING_TRAY_PARAMETERS } from '@witmetrics/utils/constants';
import ServiceParameter from '@/components/ServiceParameter';
import TabsBlock, { Tab } from '@/components/TabsBlock';
import EngravementForm from '../EngravementForm';
import type { BleachingFormSection } from './types';
import { classes } from '../utils';

export type BleachingFormProps = {
  params: BleachingFormParams;
  onChange: (params: BleachingFormParams) => void;
};

export default function BleachingForm({
  params,
  onChange,
}: BleachingFormProps) {
  const renderParam = (key: BleachingTrayParameterKey) => (
    <ServiceParameter
      parameter={BLEACHING_TRAY_PARAMETERS[key]}
      value={params[key]}
      onChange={(update) => onChange({ ...params, ...update })}
    />
  );

  return (
    <TabsBlock<BleachingFormSection[]>
      className={classes.tabsBlock}
      bodyClassName={classes.tabsBody}
      orientation="vertical"
      name="bleaching-parameters"
      defaultTab="ENGRAVEMENT">
      <Tab className={classes.tab} name="ENGRAVEMENT" label="Engravement">
        <EngravementForm
          engravedText={params.engravedText}
          onChange={(engravedText) => onChange({ ...params, engravedText })}
        />
        {renderParam('engraveMethod')}
      </Tab>
      <Tab className={classes.tab} name="RESERVOIR" label={'Reservoir'}>
        {renderParam('region')}
        {renderParam('reservoirDistanceToGingivalEdge')}
        {renderParam('reservoirDistanceToIncisalEdge')}
        {renderParam('reservoirDistanceToMdEdge')}
        {renderParam('reservoirDepth')}
      </Tab>
      <Tab className={classes.tab} name="BASING" label="Basing">
        {renderParam('baseType')}
        {renderParam('infill')}
        {renderParam('gingivaMargin')}
        {renderParam('baseHeight')}
        {renderParam('baseChamfer')}
        {renderParam('baseChamferHeight')}
        {renderParam('drainageHoles')}
        {renderParam('baseWallThickness')}
      </Tab>
      <Tab className={classes.tab} name="ATTACHMENT" label="Attachment">
        {renderParam('attachmentType')}
        {renderParam('articulatorType')}
      </Tab>
      {/*<Tab className={classes.tab} name="TRIMLINE" label="Trimline">*/}
      {/*  <TrimlineForm params={params} onChange={onChange} />*/}
      {/*</Tab>*/}
      <Tab className={classes.tab} name="OTHER" label="Other">
        {renderParam('attachmentRemoval')}
        {renderParam('impressionCleaning')}
        {params.impressionCleaning !== 'no_impression_cleaning' &&
          renderParam('artifactThreshold')}
      </Tab>
      <Tab className={classes.tab} name="ADVANCED" label="Advanced">
        {renderParam('orientation')}
        {renderParam('parallelizeBases')}
      </Tab>
    </TabsBlock>
  );
}
